// extracted by mini-css-extract-plugin
module.exports = {"banner":"banner___iU22o","inner":"inner___3dfrm"};